<template>
    <section>
                <div class="row pt-2 mx-1" v-for="(day, dayIndex) in days">
                    <div class="col-md-3">
                    <input
                        v-model="day.active"
                        id="active"
                        type="checkbox"
                        @click="checkDay(dayIndex)"
                    />
                    {{ day.name }}</div>
                    <div class="col-md-7">
                    <div class="row" v-for="(hour, hourIndex) in day.hours" v-if="day.active">
                        <select
                          v-model="hour.from"
                          class="col-md-5 px-0 m-1 bx-2 text-secondary"
                          required="true"
                        >

                            <option value="" disabled hidden></option>
                            <option
                                v-for="(hour, i) in hours"
                                :key="`hour${i}`"
                                :value="hour.id"
                            >
                                {{ hour.label }}
                            </option>
                        </select>
                        <select
                          v-model="hour.to"
                          class="col-md-5 px-0 m-1 bx-2 text-secondary"
                          required="true"
                        >

                            <option value="" disabled hidden></option>
                            <option
                                v-for="(hour, i) in hours"
                                :key="`hour${i}`"
                                :value="hour.id"
                            >
                                {{ hour.label }}
                            </option>
                        </select>
                        <button v-if="hourIndex != 0" class="btn px-1 col-md-1 rounded-circle cursor-pointer btn-sm btn-muted"
                                    @click="deleteHour(dayIndex, hourIndex)" type="button">
                                    <i class="icon-trash"></i>
                                </button>
                    </div>
                </div>
                    <div class="col" v-if="day.active">
                        <button class="btn px-0 rounded-circle cursor-pointer btn-sm btn-muted"
                            @click="addHour(dayIndex)" type="button">
                            <i class="icon-plus"></i>
                        </button>
                    </div>
                </div>
    </section>
</template>

<script>
// import Slot from "@/components/Calendar/Slot.vue";

import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";

export default {
    data() {
        return {
            //days: this.avalibleSlots,
            index: 0,
            editingIndex: 0,
            formSalesKey: 0,
            selectedDays:[],
            days: [
                {   
                    id: 0,
                    active: false,
                    name: this.$t("lang.sending_days.monday"),
                    hours: [
                        {
                            from: "10",
                            to: "19"
                        },
                    ],
                },
                {   
                    id: 1,
                    name: this.$t("lang.sending_days.tuesday"),
                    active: false,
                    hours: [
                        {
                            from: "10",
                            to: "19"
                        },
                     
                    ],
                },
                   {   
                    id: 2,
                    name: this.$t("lang.sending_days.wednesday"),
                    active: false,
                    hours: [
                        {
                            from: "10",
                            to: "19"
                        },
                    ],
                },
                    {   
                    id: 3,
                    name: this.$t("lang.sending_days.thursday"),
                    active: false,
                    hours: [
                        {
                            from: "10",
                            to: "19"
                        },
                    ],
                },
                    {   
                    id: 4,
                    name: this.$t("lang.sending_days.friday"),
                    active: false,
                    hours: [
                        {
                            from: "10",
                            to: "19"
                        },
                       
                    ],
                },
                //     {   
                //     id: 5,
                //     name: this.$t("lang.sending_days.saturday"),
                //     active: false,
                //     hours: [
                //         {
                //             from: "2",
                //             to: "4"
                //         },
                      
                //     ],
                // },
                //     {   
                //     id: 6,
                //     name: this.$t("lang.sending_days.sunday"),
                //     active: false,
                //     hours: [
                //         {
                //             from: "2",
                //             to: "4"
                //         },
                      
                //     ],
                // }
            ],
        }
    },

    components: {
        IndustrySearch
    },

    watch: {
        days: {
            handler: function (val, oldVal) {
                this.emitAvailability();
            },
            deep: true
        }
    },


    props: {
        hours: {
            type: Array,
            default: null,
        },
        avalibleSlots:{
            type: Array,
            default: function(){
                return 
            },
        },
    },

    created(){
        
        if(this.avalibleSlots.length == 0){
            this.days.map((day)=>{
                day.active = true
            })
        }
        this.avalibleSlots.map((item)=>{
            this.days[item.id].active = true
            this.days[item.id].hours = item.hours
        })
    },
    methods: {
        deleteHour(day, hour) {
            // console.log(day, hour);
            // console.log(this.days[day].hours[hour]);
            this.days[day].hours.splice(hour,1);
        },
        addHour(day){
            this.days[day].hours.push(
                {
                    from: "",
                    to: ""
                },
            );
        },
        checkDay(day){
            //console.log(day);
            if(this.days[day].active && (this.days[day].hours.length == 0)){
                this.addHour(day);
                this.addHour(day);
            }
        },
        emitAvailability(){
            this.selectedDays = [];
            this.days.map((item)=>{
              if(item.active){
                  this.selectedDays.push({
                    id: item.id,
                    hours:item.hours
                  })
              }
            })
           
            this.$emit('SetAvailability', this.selectedDays);
        },
    }
}
</script>